import {
  Component,
  NgZone,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'

import {ModalService} from '../../services/modal/modal.service'

@Component({
  selector: 'modal',
  template: `
    <ng-container #content></ng-container>
  `,
  standalone: false
})
export class ModalComponent {
  private $element
  @ViewChild('content', { static: true, read: ViewContainerRef }) content

  constructor(
    private ngZone: NgZone,
    private modalService: ModalService,
    private viewContainerRef: ViewContainerRef
  ) {
    modalService.onOpen.subscribe(o => this.open(o.component, o.options))
    modalService.onClose.subscribe(() => this.close())
  }

  open(component, options = {}) {
    const componentRef = this.viewContainerRef.createComponent(component)
    this.$element = $(componentRef.location.nativeElement).find('.ui.modal')
    if (this.$element.length === 0) {
      throw new Error('There is no element with .ui.modal in the inputted modal')
    }

    const inputs = options['inputs'] || {}
    for (const key in inputs) {
      componentRef.instance[key] = inputs[key]
    }

    const outputs = {}
    for (const key of (options['outputs'] || [])) {
      outputs[key] = componentRef.instance[key]
    }

    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        this.$element.modal({
          closable: options['closable'],
          autofocus: options['autofocus'] || false,
          observeChanges: true,
          onShow: () => {
            if (!componentRef.changeDetectorRef['destroyed']) {
              componentRef.changeDetectorRef.detectChanges()
            }
            this.ngZone.run(() => {
              this.modalService.onOpened.emit({outputs: outputs})
            })
            setTimeout(() => this.$element.modal('refresh'))
          },
          onHidden: () => {
            if (component['ngOnDestroy']) {
              this.ngZone.run(() => {
                component['ngOnDestroy']()
              })
            }
            this.content.clear()
            this.removeNode()
            this.ngZone.run(() => {
              this.modalService.onHidden.emit()
            })
          },
          onApprove: options['onApprove'],
          onDeny: options['onDeny']
        }).modal('show')
      })
    }, 0)
  }

  close() {
    this.$element.modal('hide')
  }

  private removeNode() {
    const element = this.$element[0]
    const parentNode = element.parentNode
    parentNode.removeChild(element)
  }
}
